import { render, staticRenderFns } from "./MpBack.vue?vue&type=template&id=000d1007&"
import script from "./MpBack.vue?vue&type=script&lang=js&"
export * from "./MpBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports